import { render, staticRenderFns } from "./egrulRecordsTable.vue?vue&type=template&id=11608fd2&scoped=true&"
import script from "./egrulRecordsTable.vue?vue&type=script&lang=js&"
export * from "./egrulRecordsTable.vue?vue&type=script&lang=js&"
import style0 from "./egrulRecordsTable.vue?vue&type=style&index=0&id=11608fd2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11608fd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11608fd2')) {
      api.createRecord('11608fd2', component.options)
    } else {
      api.reload('11608fd2', component.options)
    }
    module.hot.accept("./egrulRecordsTable.vue?vue&type=template&id=11608fd2&scoped=true&", function () {
      api.rerender('11608fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/egrulRecords/egrulRecordsTable.vue"
export default component.exports